import { render, staticRenderFns } from "./DownloadResume.vue?vue&type=template&id=346968ab"
import script from "./DownloadResume.vue?vue&type=script&lang=ts"
export * from "./DownloadResume.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('346968ab')) {
      api.createRecord('346968ab', component.options)
    } else {
      api.reload('346968ab', component.options)
    }
    module.hot.accept("./DownloadResume.vue?vue&type=template&id=346968ab", function () {
      api.rerender('346968ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/DownloadResume.vue"
export default component.exports